import { store } from 'store/createStore';

const useAuth = () => {
  try {
    return store.getState().auth;
  } catch (err) {
    return null;
  }
};

export default useAuth;
